var content = (function (module) {
var css = { id: module.id, exports: {} };
(function (module) {
exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".syncUserButton {\n  color: #6b75f0;\n  cursor: pointer;\n}\n", "",{"version":3,"sources":["SyncUserModal.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;AACjB","file":"SyncUserModal.css","sourcesContent":[".syncUserButton {\n  color: #6b75f0;\n  cursor: pointer;\n}\n"]}]);


})(css);
return css.exports;
}) (module);
var loader = require("/home/ubuntu/trooprbot-ui/node_modules/antd-theme/lib/loadThemedStyles.js");

if(typeof content === "string") content = [[module.id, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;